VP = window.VP || {};

(function( $ ) {
	VP.showMore = {
		init: function () {
			var _this = this;
			_this.eventHandlers();
		},

		eventHandlers: function() {
			var _this = this;
			var _target = $('.js-show-more');

			_target.click( function (e) {
				e.preventDefault();

				$(this).addClass( 'js-hide' );

			} );

		},

	};
})(jQuery);
